export default "__VITE_ASSET__2a1319cb__"